/*  ========================================================================
    # Scripts - Footer Toggle
    ========================================================================  */

/**
 * Script that triggers the mobile Footer
 */

const FooterToggle = {
  cfg: {
    menuToggles: document.querySelectorAll('.c-footer__menu-toggle'),
    menuWrapperClass: 'c-footer__menu-wrapper',
    states: {
      activeButton: 'c-footer__menu-toggle--active',
      activeMenuWrapper: 'c-footer__menu-wrapper--active'
    }
  },

  /**
   * Handle menu toggle click
   */
  handleMenuToggles() {
    if (this.cfg.menuToggles.length > 0) {
      this.cfg.menuToggles.forEach(toggle => {
        toggle.addEventListener('click', e => {
          const submenuWrapper = document.getElementById(e.target.dataset.for);
          e.target.classList.toggle(this.cfg.states.activeButton);
          submenuWrapper.classList.toggle(this.cfg.states.activeMenuWrapper);
        });
      });
    }
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.menuToggles) {
      this.handleMenuToggles();
    }
  }
};

export default FooterToggle;
